export const REQUIRED_LEGAL_PAGES = [
  {
    key: 'about',
    slug: 'hakkimizda',
    title: 'Hakkımızda',
    category: 'corporate',
    content: `
<h2><span class="brand-wordmark brand-wordmark-md">GAPPAQ</span> Hakkında</h2>
<p><span class="brand-wordmark brand-wordmark-inline">GAPPAQ</span>, aile odaklı hazır giyim ürünlerini güvenli ve hızlı alışveriş deneyimiyle buluşturan bir e-ticaret platformudur.</p>
<p>Kadın, erkek, çocuk ve bebek kategorilerinde her sezon güncellenen koleksiyonlarla hizmet verir.</p>
<h3>Müşteri Önceliğimiz</h3>
<p>Müşteri memnuniyeti, şeffaf iletişim ve güvenli ödeme süreçleri temel önceliğimizdir.</p>
    `.trim(),
  },
  {
    key: 'deliveryAndReturn',
    slug: 'teslimat-ve-iade-sartlari',
    title: 'Teslimat ve İade Şartları',
    category: 'legal',
    content: `
<h2>Teslimat Koşulları</h2>
<p>Siparişler, ödeme onayından sonra işleme alınır ve stok durumuna göre kargoya teslim edilir.</p>
<p>Teslimat süreleri yoğunluk ve resmi tatil dönemlerinde değişiklik gösterebilir.</p>
<h2>İade Koşulları</h2>
<p>Tüketici mevzuatına uygun olarak, kullanılmamış ürünleri yasal süre içinde iade edebilirsiniz.</p>
<p>İade sürecinde ürünlerin orijinal ambalajı ve fatura bilgisi ile gönderilmesi gerekir.</p>
    `.trim(),
  },
  {
    key: 'privacy',
    slug: 'gizlilik-sozlesmesi',
    title: 'Gizlilik Sözleşmesi',
    category: 'legal',
    content: `
<h2>Gizlilik ve Veri Koruma</h2>
<p>Kişisel verileriniz, yürürlükteki mevzuata uygun şekilde işlenir ve korunur.</p>
<p>Sipariş, teslimat ve müşteri hizmetleri süreçleri dışında verileriniz üçüncü kişilerle paylaşılmaz.</p>
<h3>Veri Güvenliği</h3>
<p>Alışveriş ve üyelik işlemleri güvenli iletişim protokolleri üzerinden yürütülür.</p>
    `.trim(),
  },
  {
    key: 'distanceSales',
    slug: 'mesafeli-satis-sozlesmesi',
    title: 'Mesafeli Satış Sözleşmesi',
    category: 'legal',
    content: `
<h2>Mesafeli Satış Sözleşmesi</h2>
<p>Bu sözleşme, elektronik ortamda verilen siparişlerde alıcı ve satıcının hak ve yükümlülüklerini düzenler.</p>
<p>Siparişin tamamlanmasıyla birlikte alıcı, sözleşme koşullarını okuduğunu ve kabul ettiğini beyan eder.</p>
<h3>Uyuşmazlık ve Yasal Haklar</h3>
<p>Uyuşmazlıklarda, ilgili tüketici mevzuatı kapsamında yetkili mercilere başvuru hakkı saklıdır.</p>
    `.trim(),
  },
];

export const REQUIRED_LEGAL_PAGE_SLUGS = REQUIRED_LEGAL_PAGES.map((page) => page.slug);
